// extracted by mini-css-extract-plugin
export var arrow = "ScrollToTop-module--arrow--e7f36";
export var box = "ScrollToTop-module--box--c9878";